import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import MainStore from '@src/pages/main/store';
import Page from '../../components/page';
import TopMenu from '@src/business-components/top-menu';
import { Element } from 'react-scroll';
import News from '@src/pages/main/components/news';
import Feature from '@src/pages/main/components/feature';
import School from '@src/pages/main/components/school';
import Strategy from '@src/pages/main/components/strategy';
import Audition from '@src/pages/main/components/audition';
import OfficialCommunity from '@src/business-components/official-community';
import aos from '@src/utils/aos';
import CountUp from 'react-countup';
import Link from '@src/components/link';
import BackgroundImage from '@src/components/background-image';
import cx from 'classnames';
import AgeAppropriateTips from '@src/components/age-appropriate-tips';
import '@src/components/xau-animation-css';
const styles = require('./index.less');

const Main = () => {
  const store = useStore(() => new MainStore());

  const renderBtnGroup = () => {
    if (store.state === 1 || store.state === 2) {
      return (
        <div className="main-group-5" data-name="下载矩阵" {...aos.FADE_IN()} data-aos-delay="200">
          <Link className="main-layer-11" aria-label="下载游戏" onClick={store.onDownloadClick} />
          <Link className="main-layer-12" aria-label="官方充值" onClick={store.onRechargeClick} />
        </div>
      );
    } else if (store.state === 3) {
      return (
        <div className="main-group-3" data-name="预约" {...aos.FADE_IN()} data-aos-delay="400">
          <div className="main-group-4" data-name="预约人数">
            <div className="main-layer-8" />
            <CountUp className="main-layer-9" start={0} end={store.subscribeCount} separator={','} />
            <div className="main-layer-7" />
          </div>

          <Link className="main-layer-10" onClick={store.onAppointmentClick} />
        </div>
      );
    }
  };

  return (
    <Page className={styles.root}>
      {/* <div className={styles.test} /> */}
      <div className={cx('main-root', store.hideData && 'hideData')}>
        <div className="main-layer-1">{store.kvImageMo && <BackgroundImage src={store.kvImageMo} />}</div>
        <div className="main-layer-2" />
        <TopMenu store={store.topMenuStore} />
        <div className="main-group-1" data-name="首屏内容">
          {store?.kvData?.kv_pv_video &&
            store?.kvData?.kv_play_conctrol && (
              <div className={styles.pv_video} style={{ backgroundImage: `url(${store?.kvData?.kv_play_bg_img})` }} onClick={store.onKvVideoClick}>
                <div className={styles.videoBox}>
                  <div className={cx(styles.videoBtn)} />
                </div>
              </div>
            )}

          <div className="main-layer-5">
            <AgeAppropriateTips gameName={'剑侠世界4'} />
          </div>

          {renderBtnGroup()}
          <div className={styles.iconDownArrow} />

          {/* <div className="main-layer-6" {...aos.ZOOM_IN()} data-aos-delay="200" />
          <div className="main-layer-15" {...aos.ZOOM_IN()} data-aos-delay="200" /> */}
        </div>

        <Element id="news" className="main-group-7" data-name="新闻">
          <News store={store.newsStore} />
        </Element>

        <Element id="feature" className="main-group-21" data-name="游戏特色">
          <Feature store={store.featureStore} />
        </Element>

        <Element id="school" className="main-group-25" data-name="门派">
          <School store={store.schoolStore} />
        </Element>

        {!store.hideData && (
          <Element id="data" className="main-group-36" data-name="攻略" {...aos.FADE_UP()}>
            <Strategy store={store.strategyStore} />
          </Element>
        )}

        <Element id="media" className={cx('main-group-53', store.hideData && 'hideData')} data-name="视听中心" {...aos.FADE_UP()}>
          <Audition store={store.auditionStore} />
        </Element>

        <div className={cx('main-group-54', store.hideData && 'hideData')} data-name="媒体" {...aos.FADE_UP()}>
          <OfficialCommunity store={store.officialCommunityStore} />
        </div>
      </div>
    </Page>
  );
};

export default observer(Main);
